module.exports = __webpack_public_path__ + "static/rect-e9af1623a27a5e45e687e796f17ac5ea.jpg";